import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawalDepot } from '@/types/vehicle-withdrawal-depot'
import { AxiosResponse } from 'axios'

export function updateVehicleWithdrawalDepot(
  body: Partial<VehicleWithdrawalDepot>
): Promise<AxiosResponse<VehicleWithdrawalDepot>> {
  return instance.put(`/vehicle-withdrawal-depot/${body.uuid}`, body)
}
